import * as React from 'react';

export interface ArrowIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

export function ArrowIcon(props: ArrowIconProps): JSX.Element {
    return (
        <svg width={props.width ?? 19} height={props.height ?? 19} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.6066 1.41421L9.19238 0L1.41421 7.77817L-5.1856e-06 9.19239L1.41421 10.6066L9.19238 18.3848L10.6066 16.9706L2.82842 9.19239L10.6066 1.41421Z" fill={props.fill ?? 'white'} />
        </svg>
    );
}
